import styled from "styled-components";
import { SPACING } from "../../constants/design/spacing";

export const BulletList = styled.ul`
  list-style: disc;
  margin-left: ${SPACING.three}px;
  padding-left: 0;
  text-align: left; /* Align text to the left */
`;
